export default __webpack_public_path__ + "static/media/5goo.0921d000.jpg";